import { FC, useEffect, useState } from 'react';
import { Box, Modal, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import RightArrowIcon from '../../../../../assets/icons/user-info/Right.png';
import TravelBagIcon from '../../../../../assets/icons/user-info/travel-bag.png';
import CustomButton from '../../../../../common/CustomButton';
import ContactModal from '../../../../../common/ContactModal';
import { useAppDispatch, useAppSelector } from '../../../../../hooks/redux';
import { setEmergencyContactList } from '../../../../../store/slices/customizeSlice';
import { useGetContactsQuery } from '../../../../../store/services/userContactsApi';

import styles from './TravelBuddiesContacts.module.scss';

type TravelBuddiesContactsProps = {}

const TravelBuddiesContacts: FC<TravelBuddiesContactsProps> = () => {
  const dispatch = useAppDispatch();
  const [openModal, setOpenModal] = useState<number | null>(null);
  const [newContactOpenModal, setNewContactOpenModal] = useState<boolean>(false);
  const { access } = useAppSelector((state) => state.auth.userInfo);
  const emergencyContacts = useAppSelector((state) => state.customize.emergencyContacts);
  const { data: contactsListAPI } = useGetContactsQuery(access);

  useEffect(() => {
    if (contactsListAPI) {
      dispatch(setEmergencyContactList(contactsListAPI));
    }
  }, [contactsListAPI, dispatch]);

  const handleModalOpen = (id: number | null) => setOpenModal(id);
  const handleModalClose = () => setOpenModal(null);
  const handleNewContactModalOpen = () => setNewContactOpenModal(true);
  const handleNewContactModalClose = () => setNewContactOpenModal(false);

  return (
    <Box className={styles.contacts}>
      <Box className={styles.contactsHeader}>
        <Typography variant='h7Bold'>Travel buddies</Typography>
        <Typography variant='h10'>Your reliable contacts. (Add up to 3 people)</Typography>
      </Box>
      {emergencyContacts && emergencyContacts.filter(contact => contact.type === 'Travel Buddy').map(item => (
        <Box key={item.id} className={styles.contactsContent}>
          <Modal
            open={openModal === item.id}
            onClose={handleModalClose}
            aria-labelledby={item.id ? `modal-title-${item.id}` : undefined}
            aria-describedby={item.id ? `modal-desc-${item.id}` : undefined}
            sx={{
              "& .MuiBackdrop-root": {
                backgroundColor: 'rgba(34, 43, 58, 0.2)'
              },
            }}
          >
            <Box sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              maxWidth: 'fit-content',
              minWidth: 375,
              width: '100%',
              bgcolor: 'background.paper',
              borderRadius: "20px",
              p: '32px 64px',
              overflowY: 'auto',
              boxShadow: 'none',
              maxHeight: '90vh',
              '@media (max-width: 900px)': {
                p: '16px 32px',
              },
            }}>
              <Box sx={{ position: 'absolute', top: 16, right: 20, cursor: 'pointer' }}>
                <CloseIcon sx={{width: '30px', height: '30px'}} onClick={handleModalClose} />
              </Box>
              <ContactModal
                closeModal={handleModalClose}
                contacts={item}
                type="Travel Buddy"
                targetId={item.id}
              />
            </Box>
          </Modal>

          <Box className={styles.contactsBtnWrapper} onClick={() => handleModalOpen(item.id)}>
            <Box className={styles.contactsBtnTextContent}>
            <Typography variant='h11Semibold' sx={{display: 'flex', alignItems: 'center', gap: '6px'}}>
                <img src={TravelBagIcon} alt='travel bag icon' />
                {`${item.first_name} ${item.last_name}`}
              </Typography>
              <Typography variant='h11'>{`${item.relationship}, ${item.email}, ${item.phone_number}`}</Typography>
            </Box>

            <img src={RightArrowIcon} className={styles.contactsBtnIcon} alt='right arrow' />
          </Box>
        </Box>
      ))}
      <Modal
        open={newContactOpenModal}
        onClose={handleNewContactModalClose}
        aria-labelledby={'New Contact'}
        aria-describedby={'New Contact'}
        sx={{
          "& .MuiBackdrop-root": {
            backgroundColor: 'rgba(34, 43, 58, 0.2)'
          },
        }}
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          maxWidth: 'fit-content',
          minWidth: 375,
          width: '100%',
          bgcolor: 'background.paper',
          borderRadius: "20px",
          p: '32px 64px',
          overflowY: 'auto',
          boxShadow: 'none',
          maxHeight: '90vh',
          '@media (max-width: 900px)': {
            p: '16px 32px',
          },
        }}>
          <Box sx={{ position: 'absolute', top: 16, right: 20, cursor: 'pointer' }}>
            <CloseIcon sx={{width: '30px', height: '30px'}} onClick={handleNewContactModalClose} />
          </Box>
            <ContactModal
              type="Travel Buddy"
              closeModal={handleNewContactModalClose}
            />
        </Box>
      </Modal>
      <Box className={styles.btnWrapper}>
      <CustomButton
          variant='outlined'
          disabled={emergencyContacts.filter(contact => contact.type === 'Travel Buddy')?.length >= 3}
          customClass={styles.btn}
          onClick={handleNewContactModalOpen}
        >
          + Add new
        </CustomButton>
      </Box>
    </Box>
  )
}

export default TravelBuddiesContacts;
